import { Component, OnInit, Inject } from '@angular/core';
import { AppSettingsServiceProvider } from '../../../_services/app-settings.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogCloseService } from 'src/app/_services/dialogClose.service';
import { MaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared.module';
import { LoadingService } from 'src/app/_services/loading.service';


@Component({
  selector: 'app-name-id-types',
  templateUrl: './name-id-types.component.html',
  imports: [
    SharedModule,
    MaterialModule
  ],
  standalone: true
})
export class NameIdTypesComponent implements OnInit {
  startNameIdType: string;
  endNameIdType: string;
  inValidRange: boolean = false;
  constructor(private appSettings: AppSettingsServiceProvider,
    public dialogRef: MatDialogRef<NameIdTypesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private closeDialogService: DialogCloseService, private blockUI: LoadingService) {
    this.startNameIdType = this.data.startNameIdType;
    this.endNameIdType = this.data.endNameIdType;
    this.getNameIdTypes();
    this.closeDialogService.emitRegisterDialog(dialogRef);
  }
  nameIdTypes: any;
  ngOnInit() {
  }
  getNameIdTypes() {
    this.blockUI.start();
    this.appSettings.GetNameIdTypes().then((nameIdTypes) => {
      console.log(nameIdTypes);
      this.nameIdTypes = nameIdTypes;
      this.blockUI.stop();
    }).catch(e => {
      console.log(e);
    });
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
  saveRange() {
    if (!this.endNameIdType || (this.endNameIdType && this.startNameIdType.charCodeAt(0) <= this.endNameIdType.charCodeAt(0))) {
      this.inValidRange = false;
      this.dialogRef.close({ startNameIdType: this.startNameIdType, endNameIdType: this.endNameIdType });
    }
    else {
      this.inValidRange = true;
    }

  }
  reset() {
    this.startNameIdType = '';
    this.endNameIdType = '';
  }
}
